import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AlternativeContactsService } from '@/shared/api/rest/services/alternative-contacts.service'
import { useAlertService } from '@/shared/lib/useAlertService'

export const useDeleteAlternativeContact = () => {
    const alertService = useAlertService()
    const queryClient = useQueryClient()

    const { mutateAsync, isPending, error } = useMutation({
        mutationFn: (vars: { id: string; parentId?: string; childId?: string }) =>
            AlternativeContactsService.remove(vars.id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['alternative-contacts'] })
        }
    })

    const handleDeleteContact = async (
        id: string,
        parentId?: string,
        childId?: string
    ) => {
        try {
            return await mutateAsync({ id, parentId, childId })
        } catch (error: any) {
            alertService.error(error.message)
        }
    }

    return { handleDeleteContact, loading: isPending, error: error ?? undefined }
}
